module.exports = __webpack_public_path__ + "static/media/jpm-contracts-ltd.7851df9c.jpg";